window.$ = $;
window.jQuery = jQuery;

import * as rwd from './rwd';
import * as klaro from './klaro';
import * as formValidation from './formValidation';
import * as gespraechstatusValidation from './gespraechstatusValidation';
import * as favoriteMatchings from './favoriteMatchings';
import * as filterSummary from './frontend/filterSummary';
import * as profile from './frontend/profile';
import * as programmverwaltung from './frontend/programmverwaltung';
import * as profileView from './frontend/profileView';
import * as counter from './frontend/counter';
import * as home from './frontend/home';
import * as general from './frontend/general';
import * as kiAnbieter from './frontend/kiAnbieter';
import * as kiMarktplatz from './frontend/kiMarktplatz';
import * as register from './frontend/register';
import * as messages from './frontend/messages';
import * as profileMyAccount from './frontend/profileMyAccount';
import * as search from './frontend/search';
import * as successStories from './frontend/successStories';
import * as useCases from './frontend/useCases';
import * as filterInvestmentsummary from './frontend/filterInvestmentsummary';
import * as favorites from './frontend/favorites';
import * as login from './frontend/login';

$(document).ready(function () {
  // Tooltips aktivieren
  $('[data-toggle="tooltip"]').tooltip();

  // Hilfsklassen abhängig von Viewport-Breite
  rwd.init();

  // Cookie-Hinweis
  klaro.init();

  // JS für alle Seiten
  general.init();

  // Formular-Validierungen
  formValidation.init();

  // Gesprächstatus-Formular-Validierung
  gespraechstatusValidation.init();

  // Favorit-Matchings ISNC
  favoriteMatchings.init();

  // Filter für Investment-/Cooperation-Summaries
  filterSummary.init();

  // JS für Profil
  profile.init();

  // JS für öffentliche Profilansicht
  profileView.init();

  // JS für Account-Einstellungen
  profileMyAccount.init();

  // User click Counter
  counter.init();

  // Programmverwaltung
  programmverwaltung.init();

  // JS für Startseite
  home.init();

  // JS für KI-Anbieter
  kiAnbieter.init();

  // JS für KI-Marktplatz
  kiMarktplatz.init();

  // JS für Registrierung
  register.init();

  // JS für Nachrichten
  messages.init();

  // JS für Suche
  search.init();

  // JS für Videos
  successStories.init();

  // JS für Use-Cases
  useCases.init();

  // JS für Investmentsummary Filter
  filterInvestmentsummary.init();

  // JS für EQF Favoriten
  favorites.init();

  // JS für Login
  login.init();
});
